import React, { useRef } from 'react';

import { useToggle, useCollapsible } from '../../hooks';
import { classNames } from '../../utils/css';

import DropdownLink from './dropdownLink';

const DropdownCollapse = ({
  label,
  data,
}) => {
  const [expanded, toogleExpanded] = useToggle(false);

  const contentRef = useRef(null);

  const { heightContent } = useCollapsible({ contentRef, expanded });

  return (
    <div className="dropdown__menu__item__collapse">
      <button
        type="button"
        onClick={() => toogleExpanded()}
        className={classNames('dropdown__menu__item__collapse__btn', {
          "dropdown__menu__item__collapse__open": expanded,
        })}
      >
        <span>{label}</span>

        <span className="dropdown__menu__item__collapse__btn__arrow">
          ▸
        </span>
      </button>

      <div
        className={classNames(
          "dropdown__menu__item__collapse__content",
          {
            "dropdown__menu__item__collapse__open": expanded,
          },
        )}
        style={{ height: heightContent }}
      >
        <div ref={contentRef}>
          {data.map(({ title, path }) => (
            <DropdownLink
              key={`dropdown-menu-item-collapse-${title}`}
              title={title}
              path={path}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DropdownCollapse;
